import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'inicio',
    component: () => import('@/views/cliente/Inicio.vue')
  }, {
    path: '/productos',
    name: 'productos',
    component: () => import('@/views/cliente/Productos.vue')
  },
  {
    path: "*",
    component: () => import('@/views/cliente/Inicio.vue')
  },
  {
    path: '/noticias',
    name: 'noticias',
    component: () => import('@/views/cliente/Noticias.vue')
  },
  {
    path: '/noticia/:id',
    name: 'noticia',
    component: () => import('@/views/cliente/Noticia.vue')
  },
  {
    path: '/nosotros',
    name: 'nosotros',
    component: () => import('@/views/cliente/Nosotros.vue')
  }, {
    path: '/clientes',
    name: 'clientes',
    component: () => import('@/views/cliente/Clientes.vue')
  }, {
    path: '/contacto',
    name: 'contacto',
    component: () => import('@/views/cliente/Contacto.vue')
  },
  /* Productos */
  {
    path: '/SdmWeb',
    name: 'SdmWeb',
    component: () => import('@/views/cliente/productos/SdmWeb.vue')
  }, {
    path: '/SdmMovil',
    name: 'SdmMovil',
    component: () => import('@/views/cliente/productos/SdmMovil.vue')
  }, {
    path: '/domit',
    name: 'Domit',
    component: () => import('@/views/cliente/productos/Domit.vue')
  }, {
    path: '/task',
    name: 'Task',
    component: () => import('@/views/cliente/productos/Task.vue')
  }, 
  // {
  //   path: '/ponche',
  //   name: 'Ponche',
  //   component: () => import('@/views/cliente/productos/Ponche.vue')
  // },
  /* Sectores comerciales */
  {
    path: '/sectores/retail',
    name: 'retail',
    component: () => import('@/views/cliente/admin_modulos/Retail.vue')
  }, {
    path: '/sectores/hosteleria',
    name: 'hosteleria',
    component: () => import('@/views/cliente/admin_modulos/Hosteleria.vue')
  }, {
    path: '/sectores/industrias',
    name: 'industrias',
    component: () => import('@/views/cliente/admin_modulos/Industrias.vue')
  }, {
    path: '/sectores/salud',
    name: 'salud',
    component: () => import('@/views/cliente/admin_modulos/Salud.vue')
  }, {
    path: '/sectores/hoteles',
    name: 'hoteles',
    component: () => import('@/views/cliente/admin_modulos/Hoteles.vue')
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router